import foo from './foo';
import bar from './bar';

console.log( 'hello from main.js' );

foo();
bar();
